// Timeframe + symbol helpers (timeframes are defined once in the engine)
export { TIMEFRAMES, TICK_TIMEFRAMES, ALL_TF, getTf } from "../engine/data/Timeframes";
import { SymbolCatalog } from "../engine/data/SymbolCatalog";

// Offline fallback only — the live catalogue comes from Deriv active_symbols via the backend (see SymbolCatalog).
export const SYMBOL_META = {
  "1HZ50V": { display: "V50 1s", name: "Volatility 50 (1s) Index", category: "synthetic_index", decimals: 2 },
  R_50: { display: "V50", name: "Volatility 50 Index", category: "synthetic_index", decimals: 4 },
  "1HZ75V": { display: "V75 1s", name: "Volatility 75 (1s) Index", category: "synthetic_index", decimals: 2 },
  R_75: { display: "V75", name: "Volatility 75 Index", category: "synthetic_index", decimals: 4 },
  "1HZ100V": { display: "V100 1s", name: "Volatility 100 (1s) Index", category: "synthetic_index", decimals: 2 },
  R_100: { display: "V100", name: "Volatility 100 Index", category: "synthetic_index", decimals: 2 },
  "1HZ25V": { display: "V25 1s", name: "Volatility 25 (1s) Index", category: "synthetic_index", decimals: 2 },
  "1HZ10V": { display: "V10 1s", name: "Volatility 10 (1s) Index", category: "synthetic_index", decimals: 2 },
  cryBTCUSD: { display: "BTCUSD", name: "Bitcoin / US Dollar", category: "cryptocurrency", decimals: 2 },
  frxEURUSD: { display: "EURUSD", name: "Euro / US Dollar", category: "forex", decimals: 5 },
};

export const DEFAULT_FAVORITES = ["1HZ10V", "1HZ25V", "1HZ50V", "1HZ75V", "1HZ100V", "cryBTCUSD", "frxEURUSD"];

export function meta(code) {
  const c = SymbolCatalog.get(code);
  if (c) return { display: c.display, name: c.name, category: c.market, market: c.market_display, submarket: c.submarket_display, decimals: c.decimals, open: c.exchange_is_open, suspended: c.is_trading_suspended };
  return SYMBOL_META[code] || { display: code, name: code, category: "other", decimals: 2 };
}

export function fmtPrice(v, decimals = 2) {
  if (v == null || isNaN(v)) return "—";
  return v.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
